<template>
  <nav class="header-nav">
    <a href="/" class="page-title site-title" aria-label="Go to homepage">Austin Studio Tour</a>
    <ul>
      <li :class="{active: $route.name.includes('participant')}"><button @click="routeTo('/participants', 'none')">Participants</button></li>

      <li :class="{active: $route.name === 'map'}"><button @click="routeTo('/map', 'none')">Map</button></li>

      <li :class="{active: $route.name.includes('partner')}"><button @click="routeTo('/partners', 'none')">Partners</button></li>

      <li :class="{active: $route.name === 'events'}"><button @click="routeTo('/events', 'none')">Event Guide</button></li>

      <!-- <li :class="{active: $route.name === 'themedtours'}"><button @click="routeTo('/themedtours', 'none')">Themed Tours</button></li> -->
    </ul>
  </nav>
</template>

<script>
export default {
  methods: {
    routeTo(loc, transition) {
      this.$router.push(loc);
      if (transition) {
        this.$parent.transitionOverride = transition;
      }
    },
  }
};
</script>

<style scoped lang="less">
@import '../css/variables';

.header-nav {
  .page-title {
    &.site-title {
      display: inline;
      font-family: @fontSecondary;
      text-decoration: none;
      @media (max-width: @mobile) {
        display: none;
      }
    }
  }

  > ul {
    display: flex;
    justify-content: center;
    align-items: center;
    @media (max-width: @mobile) {
      display: none;
    }
    > li {
      padding: 0 20px;
      button {
        font-weight: normal;
      }
      &.active,
      &:hover {
        > button {
          color: @themeColor3;
        }
      }
      &.has-subnav {
        &:hover {
          .subnav {
            transform: translate(-20px, 0);
          }
        }
      }
    }
    button {
      position: static;
    }
  }

  .subnav {
    position: absolute;
    transform: translate(-20px, -100vh);
    display: block;
    padding: 10px 20px;
    background-color: #000;
    text-align: left;
    border-radius: 0 0 10px 10px;
    &.active,
    &:focus-within {
      transform: translate(-20px, 0);
    }
    @media (max-width: @mobile) {
      display: none;
    }
    li {
      padding: 13px 0;
      &.active,
      &:hover {
        > button {
          color: @themeColor1;
        }
      }
    }
    button {
      color: #fff;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/HeaderNav.vue